var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53845 28.209C9.76214 29.9577 12.567 31.0008 15.6154 31.0008C18.6638 31.0008 21.4686 29.9577 23.6923 28.209",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7692 5.42188C6.42407 7.06427 2.53845 12.0404 2.53845 17.924C2.53845 19.4047 2.78452 20.8278 3.23799 22.1548",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4614 5.42188C24.8066 7.06427 28.6922 12.0404 28.6922 17.924C28.6922 19.4047 28.4461 20.8278 27.9927 22.1548",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2308 25.6157C30.2308 26.6477 29.8243 27.5847 29.1628 28.2755C28.4627 29.0066 27.4768 29.4618 26.3846 29.4618C24.2605 29.4618 22.5385 27.7398 22.5385 25.6157C22.5385 24.0695 23.4508 22.7364 24.7667 22.1254C25.2585 21.897 25.8067 21.7695 26.3846 21.7695C28.5088 21.7695 30.2308 23.4915 30.2308 25.6157Z",
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69231 25.6157C8.69231 26.6477 8.28585 27.5847 7.62438 28.2755C6.92423 29.0066 5.93838 29.4618 4.84615 29.4618C2.72198 29.4618 1 27.7398 1 25.6157C1 24.0695 1.91242 22.7364 3.22821 22.1254C3.72003 21.897 4.26821 21.7695 4.84615 21.7695C6.97031 21.7695 8.69231 23.4915 8.69231 25.6157Z",
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4617 4.84615C19.4617 5.87815 19.0553 6.81515 18.3938 7.50592C17.6936 8.23708 16.7078 8.69231 15.6156 8.69231C13.4914 8.69231 11.7694 6.97031 11.7694 4.84615C11.7694 3.29993 12.6818 1.96682 13.9976 1.35585C14.4894 1.12748 15.0376 1 15.6156 1C17.7397 1 19.4617 2.72198 19.4617 4.84615Z",
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.9f57c5cda5847cc2484bf11b547f453a.svg";
export { ForwardRef as ReactComponent };